// deps
import React, { memo } from "react";

// internal-deps
import { isEmpty } from "@swiggy-private/core-ui";

// components
import SplitBillWidgetLottie from "../SplitBillWidgetLottie/SplitBillWidgetLottie";
import SplitBillWidget from "./SplitBillWidget";

// utils
import {
    getCurrentSplitWidgetStateFromApi,
    getSplitBillWidgetViewState,
} from "./splitBillWidgetUtils";

// interfaces
import type { ISplitPayWidget } from "@dineout-payment-success-ui/interfaces";

interface SplitBillWidgetSectionProps {
    splitPayWidget?: ISplitPayWidget;
    splitBillSuccess?: boolean;
    currentSplitWidgetState?: string;
    onClick: VoidFunction;
    onImpression?: VoidFunction;
}

const SplitBillWidgetSection: React.FC<SplitBillWidgetSectionProps> = ({
    splitPayWidget,
    splitBillSuccess,
    currentSplitWidgetState,
    onClick,
    onImpression,
}) => {
    const widgetViewState =
        !isEmpty(splitPayWidget) && splitPayWidget?.states
            ? getSplitBillWidgetViewState(
                  getCurrentSplitWidgetStateFromApi(splitPayWidget),
                  splitPayWidget,
                  splitBillSuccess,
                  currentSplitWidgetState,
              )
            : null;
    const widgetLottieId = widgetViewState?.widgetLottieId || "";

    if (!isEmpty(widgetLottieId)) {
        return (
            <SplitBillWidgetLottie
                widgetLottieId={widgetLottieId}
                isClickable={widgetViewState?.isClickable}
                onClick={onClick}
                onImpression={onImpression}
            />
        );
    }

    return (
        <SplitBillWidget
            splitPayWidget={splitPayWidget}
            splitBillSuccess={splitBillSuccess}
            currentSplitWidgetState={currentSplitWidgetState}
            onClick={onClick}
            onImpression={onImpression}
        />
    );
};

export default memo(SplitBillWidgetSection);
